module.exports = __webpack_public_path__ + "static/media/react.f370c1e0.png";